import * as React from "react";
import { useDispatch, useSelector, useSaga } from "@grandvisionhq/state";
import { isDefined } from "@grandvisionhq/utils";
import { ConfiguratorContextProvider } from "../../../../Context/Context/ConfiguratorContext.js";
import { PrivateSteppingContextProvider } from "../../../../Context/Context/PrivateSteppingContext.js";
import { startConfigurator, nextStep, previousStep } from "../../../../state/state/actions.js";
import { configuratorFactory } from "../../../../state/state/sagas.js";
import { isFooterOpen, hasAttemptedNextStep, isLastStep } from "../../../../state/state/selectors.js";
import { getStepsList } from "../../../../state/state/selectors.internal.js";
import { Configurator } from "./Configurator.js";
const useStepHandlers = (id) => {
  const dispatch = useDispatch();
  const goToNextStep = React.useCallback(
    (e) => {
      e?.preventDefault();
      dispatch(nextStep({ id }));
    },
    [dispatch, id]
  );
  const goToPreviousStep = React.useCallback(
    (e) => {
      e?.preventDefault();
      dispatch(previousStep({ id }));
    },
    [dispatch, id]
  );
  return {
    goToPreviousStep,
    goToNextStep
  };
};
const ConfiguratorContainer = ({
  id,
  stepsMap,
  stepSequence,
  onFinish,
  lastStepCTALabelKey,
  footerExpanderContent,
  footerTopBarContent,
  hideExpanderOnLastStep,
  onModalClose,
  onTriggerDataLayer,
  ...rest
}) => {
  const dispatch = useDispatch();
  const steps = useSelector(
    (s) => getStepsList(s, { id, stepsMap, stepSequence })
  );
  const currentStepName = steps.find((s) => s.isCurrent)?.name;
  const isFooterOpen$1 = useSelector((s) => isFooterOpen(s, { id }));
  const hasAttemptedNextStep$1 = useSelector(
    (s) => hasAttemptedNextStep(s, { id })
  );
  const { rootSaga } = React.useMemo(() => configuratorFactory(id), [id]);
  const task = useSaga(
    rootSaga,
    {
      onStart(t) {
        t.setContext({ [id]: { stepsMap, stepSequence, onFinish } });
        dispatch(startConfigurator({ id, stepSequence, stepsMap }));
      }
    },
    [dispatch]
  );
  React.useEffect(() => {
    task?.setContext({ [id]: { stepsMap, stepSequence, onFinish } });
  }, [task, stepsMap, stepSequence, onFinish, id]);
  const { goToNextStep, goToPreviousStep } = useStepHandlers(id);
  const isOnLastStep = useSelector(
    (s) => isLastStep(s, { id, stepsMap, stepSequence })
  );
  if (!isDefined(currentStepName)) {
    return null;
  }
  const contextValues = {
    configuratorId: id,
    hasAttemptedNextStep: hasAttemptedNextStep$1,
    isFooterOpen: isFooterOpen$1,
    goToNextStep,
    goToPreviousStep,
    onFinish,
    onModalClose,
    onTriggerDataLayer,
    isOnLastStep
  };
  return /* @__PURE__ */ React.createElement(
    PrivateSteppingContextProvider,
    {
      configuratorId: id,
      stepsMap,
      stepSequence,
      lastStepCTALabelKey,
      footerTopBarContent,
      footerExpanderContent,
      hideExpanderOnLastStep
    },
    /* @__PURE__ */ React.createElement(ConfiguratorContextProvider, { ...contextValues }, /* @__PURE__ */ React.createElement(Configurator, { ...rest }))
  );
};
export {
  ConfiguratorContainer
};
//# sourceMappingURL=ConfiguratorContainer.js.map
